// English strings for the Outfino Creator Portal.
const en = {
  // ---- Nav ----
  'nav.how': 'How it works',
  'nav.more': 'More than a collab',
  'nav.who': 'Who can apply',
  'nav.dashboard': 'Dashboard',
  'nav.login': 'Sign in',

  // ---- Hero ----
  'hero.badge': 'Outfino Creator Program',
  'hero.title': 'Become an Outfino Creator',
  'hero.tagline': 'Create content. Build your community. Get paid for it.',
  'hero.subtitle':
    'Videos for Outfino - performance-based rewards and complimentary Circle membership.',
  'hero.ctaLogin': 'Sign in with Outfino',
  'hero.ctaLearn': 'How it works',

  // ---- How it works ----
  'how.eyebrow': 'How it works',
  'how.title': 'From application to your first paid video',
  'how.1.title': 'Sign in',
  'how.1.body': 'Your Creator profile is connected to your Outfino account.',
  'how.2.title': 'Apply to become a Creator',
  'how.2.body': 'Add your TikTok or Instagram profile. 10,000+ followers required.',
  'how.3.title': 'Receive briefs',
  'how.3.body': 'Once approved, you get briefs - with requirements and deadlines.',
  'how.4.title': 'Create your video',
  'how.4.body': 'Submit it for review on the portal. Feedback lands here too.',
  'how.5.title': 'Publish and get paid',
  'how.5.body':
    'Once approved, publish it. Rewards are per video, by performance - paid monthly, by the 10th.',

  // ---- How it works modal (dashboard tutorial) ----
  'how.modalTitle': 'How it works',
  'how.modalLead': "Here's the full flow, from applying to getting paid.",
  'how.close': 'Close',
  'how.gotIt': 'Got it',
  'how.step.apply.title': 'You apply to a brief',
  'how.step.apply.body':
    'On the Briefs tab you can apply to open briefs with one click until the application deadline. No video needed yet.',
  'how.step.select.title': 'We select creators',
  'how.step.select.body':
    'We pick a few creators from the applicants based on profile, past performance, style and audience. Only the selected ones get the "Confirmed" status and the delivery deadline.',
  'how.step.brief.title': 'You get the details',
  'how.step.brief.body':
    'For your confirmed brief you see the content requirements, the delivery deadline and the payment terms up front, and can start creating.',
  'how.step.create.title': 'Create and upload',
  'how.step.create.body':
    'Create your video(s) based on the brief, upload them into the slots, and submit for review.',
  'how.step.review.title': 'Review and feedback',
  'how.step.review.body':
    'We review your submission. If changes are needed you get feedback right here on the portal.',
  'how.step.publish.title': 'Publish',
  'how.step.publish.body':
    'Publish the approved video on the specified platform (TikTok or Instagram) per the brief terms.',
  'how.step.payout.title': 'Payout',
  'how.step.payout.body':
    'Rewards are per video, based on performance. Payouts are made monthly, by the 10th of each month. Your balance and history are on the Payouts tab.',

  // ---- More than a collaboration ----
  'more.eyebrow': 'More than a collaboration',
  'more.title': 'Help shape how the next generation discovers fashion.',
  'more.paid.title': 'Paid opportunities',
  'more.paid.body': "Every brief spells out what we want and the terms up front.",
  'more.perf.title': 'Performance-based rewards',
  'more.perf.body':
    'Rewards follow the campaign terms and your performance - paid monthly, by the 10th.',
  'more.circle.title': 'Complimentary Circle membership',
  'more.circle.body': 'Active Creators get free Outfino Circle membership.',
  'more.place.title': 'Everything in one place',
  'more.place.body': 'Briefs, submissions, reviews and status - all on the portal.',

  // ---- Who can apply ----
  'who.eyebrow': 'Who can become an Outfino Creator?',
  'who.title': 'You should apply if you…',
  'who.1': 'have at least 10,000 followers on TikTok or Instagram;',
  'who.2': 'create fashion, outfit or lifestyle content;',
  'who.3': 'want to work on recurring video campaigns;',
  'who.4': 'can turn a brief into content in your own style.',
  'who.highlight':
    "We especially love working with creators who actively use Outfino themselves - it makes the content more authentic.",
  'who.note':
    "We're not after polished ads - we want authentic creators who introduce Outfino to their own community.",

  // ---- CTA ----
  'cta.title': 'Ready to join?',
  'cta.body': 'Sign in to your Outfino account and submit your Creator application.',
  'cta.apply': 'Sign in & apply',
  'cta.note': 'Minimum 10,000 followers required on TikTok or Instagram.',

  // ---- Footer ----
  'footer.tagline':
    'Create content for Outfino and get paid for the performance of your videos.',
  'footer.product': 'Program',
  'footer.company': 'Company',
  'footer.legal': 'Legal',
  'footer.privacy': 'Privacy',
  'footer.terms': 'Terms',
  'footer.rights': 'All rights reserved.',

  // ---- Login ----
  'login.back': 'Back to home',
  'login.title': 'Creator Portal',
  'login.subtitle': 'Sign in to apply and manage your collaborations.',
  'login.email': 'Email address',
  'login.password': 'Password',
  'login.submit': 'Sign in',
  'login.loading': 'Signing in…',
  'login.wrongCredentials': 'Incorrect email or password.',
  'login.networkError': 'Network error. Please try again.',
  'login.notice': 'Use your Outfino account to sign in.',
  'login.google': 'Sign in with Google',
  'login.apple': 'Sign in with Apple',
  'login.or': 'or',
  'login.googleFailed': 'Google sign-in failed.',
  'login.googleCloseWindow': 'Signed in. You can close this window.',
  'login.appleUnavailable': 'Apple sign-in is unavailable.',
  'login.appleFailed': 'Apple sign-in failed.',

  // ---- Dashboard shell ----
  'shell.logout': 'Sign out',
  'shell.loading': 'Loading…',
  'shell.refresh': 'Refresh',
  'shell.newCount': '{count} new',
  'sidebar.expand': 'Expand',
  'sidebar.collapse': 'Collapse',
  'sidebar.menu': 'Menu',
  'sidebar.menuClose': 'Close menu',
  'theme.light': 'Light',
  'theme.dark': 'Dark',
  'theme.lightTitle': 'Light theme',
  'theme.darkTitle': 'Dark theme',
  'lang.name': 'English',
  'lang.switchTitle': 'Switch to Hungarian',
  'shell.error': 'Something went wrong. Refresh the page or try again.',
  'shell.retry': 'Retry',

  // ---- Application form (not a creator yet) ----
  'apply.title': 'Apply to become an Outfino Creator',
  'apply.subtitle':
    'Add your TikTok or Instagram profile - at least one is required.',
  'apply.req': 'Minimum 10,000 followers required on TikTok or Instagram. Give at least one profile; the rest of the fields are required.',
  'apply.tiktok': 'TikTok profile',
  'apply.tiktokPlaceholder': '@yourhandle or https://tiktok.com/@yourhandle',
  'apply.instagram': 'Instagram profile',
  'apply.instagramPlaceholder': '@yourhandle or https://instagram.com/yourhandle',
  'apply.note': 'A short note about you',
  'apply.notePlaceholder':
    'Tell us about your content, your community and why you want to create for Outfino…',
  'apply.submit': 'Submit application',
  'apply.submitting': 'Submitting…',
  'apply.needAll': 'Please fill in every field and accept both declarations before submitting.',
  'apply.errSocial': 'Add at least one profile (TikTok or Instagram).',
  'apply.errTiktok': 'Add your TikTok profile.',
  'apply.errInstagram': 'Add your Instagram profile.',
  'apply.errNote': 'Tell us a little about yourself.',
  // #597 — the two declarations. The terms sentence carries a link in its
  // middle, hence the three pieces: before + link + after.
  'apply.termsBefore': 'I accept the',
  'apply.termsLink': 'Terms and Conditions',
  'apply.termsAfter': '.',
  'apply.followersDeclaration':
    'I declare that I have at least 10,000 followers on at least one of the platforms (TikTok or Instagram).',
  'apply.errTerms': 'You must accept the Terms and Conditions.',
  'apply.errFollowers': 'You must declare that you have at least 10,000 followers.',
  'apply.pendingTitle': 'Application submitted',
  'apply.pendingBody':
    "Thanks - your application is in review. Once approved, your briefs and payouts appear right here.",
  'apply.pendingBadge': 'Pending review',
  'apply.error': 'Could not submit your application. Please try again.',

  // ---- Creator dashboard ----
  'creator.greeting': 'Your Creator Portal',
  'tab.tasks': 'Tasks',
  'tab.briefs': 'Briefs',
  'tab.payouts': 'Payouts',
  'tab.application': 'Application',

  // ---- Tasks (deadlines + countdowns) ----
  'tasks.empty': 'No tasks yet. Once you are selected for a brief, it shows up here.',
  'tasks.activeHeading': 'Awaiting delivery',
  'tasks.reviewHeading': 'In review',
  'tasks.browseBriefs': 'Open briefs',
  'tasks.pastHeading': 'History',
  'tasks.reviewTitle': 'Your videos are submitted',
  'tasks.reviewBody': 'We are reviewing them and you will get feedback here.',
  'tasks.approvedTitle': 'Your videos are approved',
  'tasks.approvedBody': 'You can see your reward on the Payouts tab.',
  'tasks.notApprovedTitle': 'Review finished',
  'tasks.notApprovedBody': 'Not all of your videos were approved. See the feedback for each video below.',
  'tasks.resultsTitle': 'Results',
  'tasks.resultsSummary': '{approved}/{total} videos approved',
  'tasks.videoN': 'Video {n}',
  'tasks.reviewNote': 'Feedback',
  'tasks.result.submitted': 'Waiting for review',
  'tasks.result.approved': 'Approved',
  'tasks.result.rejected': 'Rejected',
  'tasks.earning.pending': 'awaiting payout',
  'tasks.earning.processing': 'processing',
  'tasks.earning.completed': 'paid',
  'tasks.earning.failed': 'payout failed',
  'tasks.earning.cancelled': 'withdrawn',
  'tasks.deliveryIn': 'Delivery in',
  'tasks.deadlinePassed': 'Passed',
  'tasks.d': 'd',
  'tasks.h': 'h',
  'tasks.m': 'm',
  'tasks.s': 's',

  // ---- Briefs ----
  'briefs.title': 'Video briefs',
  'briefs.subtitle': 'Your available collaborations. Upload your videos for review.',
  'briefs.empty': 'No briefs available right now. Check back soon.',
  'briefs.group.open': 'Open',
  'briefs.group.applied': 'Applied',
  'briefs.group.not_selected': 'Not selected',
  'briefs.deadline': 'Deadline',
  'briefs.payment': 'Payment',
  'briefs.perVideo': '{amount} / video',
  'briefs.required': '{count} video',
  'briefs.required_plural': '{count} videos',
  'briefs.uploaded': '{done} / {total} uploaded',
  'briefs.more': 'Show more',
  'briefs.less': 'Show less',
  'briefs.slotHint': 'Add video',
  'briefs.slotAny': 'MP4, MOV, WebM…',
  'briefs.remove': 'Remove video',
  'briefs.submit': 'Submit for review',
  'briefs.submitting': 'Submitting…',
  'briefs.uploading': 'Uploading… {percent}%',
  'briefs.submittedShort': 'Submitted',
  'briefs.submitted': 'Submitted for review. We’ll get back to you with feedback.',
  'briefs.submitAllFirst': 'Upload all {total} videos before submitting.',
  'briefs.applyDeadline': 'Application deadline',
  'briefs.loadError': 'Could not load briefs. Please try again.',
  'briefs.applyError': 'Could not apply. Please try again.',
  'briefs.submitError': 'Could not submit. Please try again.',

  'briefs.state.open': 'Open',
  'briefs.state.applied': 'Applied',
  'briefs.state.not_selected': 'Not selected',
  'briefs.state.confirmed': 'Confirmed',
  'briefs.state.in_review': 'In review',
  'briefs.state.approved': 'Approved',
  'briefs.state.not_approved': 'Not approved',

  'briefs.apply': 'Apply to this brief',
  'briefs.applyOpenNote':
    'You can apply to this brief until the application deadline ({date}). Selected creators then receive the delivery deadline and can start creating.',
  'briefs.slotsNeeded': '{count} creators needed',
  'briefs.applicants': '{count} applicants',
  'briefs.spotsTaken': '{taken}/{total} creators selected',

  'briefs.appliedTitle': 'Applied - under review',
  'briefs.appliedBody':
    "Your application is recorded. After the application deadline we'll let you know if you were selected for this brief.",

  'briefs.notSelectedTitle': 'Not selected this time',
  'briefs.notSelectedBody':
    'Applications have closed and other creators were chosen for this brief. Check the other open briefs - the next one could be yours.',

  'briefs.confirmedTitle': "You're in - start creating!",
  'briefs.confirmedBody':
    'Congrats, you were selected for this brief. Create your videos based on the description and upload them before the delivery deadline.',

  // ---- Payouts ----
  'payouts.title': 'Payouts',
  'payouts.available': 'Available balance',
  'payouts.request': 'Request payout',
  'payouts.requesting': 'Requesting…',
  'payouts.requested': 'Payout request sent.',
  'payouts.note': 'Rewards are per video, by performance - paid monthly, by the 10th.',
  'payouts.earningsTitle': 'Earnings by brief',
  'payouts.noEarnings': 'No earnings yet.',
  'payouts.history': 'Payout history',
  'payouts.noPayouts': 'No payouts yet.',
  'payouts.status.completed': 'Completed',
  'payouts.status.pending': 'Pending',
  'payouts.loadError': 'Could not load payouts. Please try again.',
  // ---- Dev banner ----
  'dev.bannerFull': 'Development mode — visit the live version here: ',
  'dev.bannerShort': 'Development mode — ',

};

export default en;
